document.addEventListener('DOMContentLoaded', function () {
  const wishlistKey = 'shopify_wishlist';

  function getWishlist() {
    const stored = localStorage.getItem(wishlistKey);
    return stored ? JSON.parse(stored) : [];
  }

  function saveWishlist(wishlist) {
    localStorage.setItem(wishlistKey, JSON.stringify(wishlist));
  }

  function updateButtonState(btn) {
    const productHandle = btn.getAttribute('data-product-handle');
    const wishlist = getWishlist();

    if (productHandle && wishlist.includes(productHandle)) {
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
    } else {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    }
  }

  document.addEventListener('quickview:loaded', function () {
    const wishlistButtons = document.querySelectorAll('.product__wishlist-btn');
    wishlistButtons.forEach(btn => {
      updateButtonState(btn);
    });
  });

  const wishlistButtons = document.querySelectorAll('.product__wishlist-btn');
  wishlistButtons.forEach(btn => {
    updateButtonState(btn);
  });

  document.addEventListener('click', function (e) {
    let btn;
    if (e.target.matches('.product__wishlist-btn')) {
      btn = e.target;
    } else {
      return;
    }

    e.preventDefault();

    const productHandle = btn.getAttribute('data-product-handle');
    if (!productHandle) return;

    let wishlist = getWishlist();

    if (wishlist.includes(productHandle)) {
      wishlist = wishlist.filter(handle => handle !== productHandle);
    } else {
      wishlist.push(productHandle);
    }

    saveWishlist(wishlist);
    updateButtonState(btn);
  });

  document.addEventListener('submit', function (e) {
    if (!e.target.matches('.jdgm-review-widget .jdgm-form')) return;

    setTimeout(function () {
      const form = e.target;
      const offsetTop = form.getBoundingClientRect().top + window.scrollY;
      const header = document.querySelector('.site-header');
      const headerOffset = header ? header.offsetHeight : 0;

      window.scrollTo({
        top: offsetTop - headerOffset,
        behavior: 'smooth'
      });
    }, 300);
  });

  document.addEventListener('click', function (e) {
    let timeout = 0;
    if (e.target.matches('.jdgm-cancel-rev')) {
      timeout = 0;
    } else if (e.target.matches('.jdgm-write-rev-link')) {
      timeout = 500;
    } else {
      return;
    }

    e.preventDefault();
    setTimeout(function () {
      const reviewWidget = document.querySelector('.jdgm-review-widget');
      if (reviewWidget) {
        const offsetTop = reviewWidget.getBoundingClientRect().top + window.scrollY;
        const header = document.querySelector('.site-header');
        const headerOffset = header ? header.offsetHeight : 0;

        window.scrollTo({
          top: offsetTop - headerOffset,
          behavior: 'smooth'
        });
      }
    }, timeout);

  });


  const url = new URL(window.location.href);
  const paramList = ['contact_posted', 'customer_posted', 'password_posted'];

  paramList.forEach(param => {
    if (url.searchParams.get(param) === 'true') {
      url.searchParams.delete(param);

      const nextUrl =
        url.pathname +
        (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') +
        url.hash;

      window.history.replaceState({}, document.title, nextUrl);
    }
  });

  let isAddingToCart = false;

  // Use delegated submit handling so forms added after initial load are also handled.
  document.addEventListener('submit', function (evt) {
    const form = evt.target.closest('.grid-product__add-to-cart-form');
    if (!form) return;

    addItemFromForm(evt, form);
  });

  function addItemFromForm(evt, form) {
    evt.preventDefault();

    if (isAddingToCart || !form) return;

    const submitBtn = form.querySelector('[type="submit"]');


    isAddingToCart = true;
    if (submitBtn) submitBtn.classList.add('btn--loading');

    const data = new FormData(form);

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      body: data,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        return response.json().then(function (json) {
          return {ok: response.ok, data: json};
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status === 422) {
          // Keep compatibility with theme listeners
          document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
            detail: result.data
          }));
          return;
        }

        // Notify theme/UI that product was added
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {product: result.data}
        }));

        // Optional: refresh cart UI if your theme listens to this
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (error) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: {message: error && error.message ? error.message : 'Add to cart failed'}
        }));
      })
      .finally(function () {
        isAddingToCart = false;
        if (submitBtn) submitBtn.classList.remove('btn--loading');

        // Keep your existing cart-template behavior
        if (document.body.classList.contains('template-cart')) {
          window.scrollTo(0, 0);
          location.reload();
        }
      });
  }

  (function moveQuickShopModalsToBodyEnd() {
    function move() {
      var modals = document.querySelectorAll('div[id^="QuickShopModal-"]');
      if (!modals.length) return;

      modals.forEach(function(modal) {
        // Appending an existing node moves it (does not clone),
        // so this is safe and idempotent.
        document.body.appendChild(modal);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', move);
    } else {
      move();
    }

    // Optional: run again shortly in case sections/apps inject markup after initial load.
    setTimeout(move, 300);
  })();


  // SEO Content Section
  document.querySelectorAll('.seo-content-section').forEach((section) => {
    const button = section.querySelector('.seo-content-section__toggle');
    const hidden = section.querySelector('.seo-content-section__hidden');

    if (!button || !hidden) return;

    function setExpanded(isExpanded) {
      if (isExpanded) {
        hidden.classList.add('is-open');
        hidden.style.maxHeight = hidden.scrollHeight + 'px';
        hidden.setAttribute('aria-hidden', 'false');
        button.setAttribute('aria-expanded', 'true');
        button.textContent = button.dataset.showLess;
      } else {
        hidden.classList.remove('is-open');
        hidden.style.maxHeight = '0px';
        hidden.setAttribute('aria-hidden', 'true');
        button.setAttribute('aria-expanded', 'false');
        button.textContent = button.dataset.readMore;
      }
    }

    setExpanded(false);

    button.addEventListener('click', () => {
      setExpanded(!hidden.classList.contains('is-open'));
    });

    window.addEventListener('resize', () => {
      if (hidden.classList.contains('is-open')) {
        hidden.style.maxHeight = hidden.scrollHeight + 'px';
      }
    });
  });
});